/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
$('body').on('click', '.js-add-to-cart', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);
  var data = {
    quantity: 1,
    id: itemToAddToCart.data('variant-id')
  }

  if(!$(this).hasClass('single-buy')) {
    if($(this).data('shipping_interval_frequency')!="" && $(this).data('shipping_interval_unit_type')!="") {
      data.properties = {};
      data.id = itemToAddToCart.data('subscription-variant-id')
      data.properties['shipping_interval_frequency'] = $(this).data('shipping_interval_frequency');
      data.properties['shipping_interval_unit_type'] = $(this).data('shipping_interval_unit_type');
    }
  }

  if($(this).data('upsell')!="") {
    if(!data.properties) {
      data.properties = {};
    }
    data.properties['_upsell'] = $(this).data('upsell');
  }

  /*$.post('/cart/add.js', data, function(cart){
    ajaxCart.load();
    theme.RightDrawer.open();
  }, 'json');*/
});

$('body').on('click', '.subscription-swap input', function(e) {
  e.preventDefault();
  if(!$(this).hasClass('checked')) {
    $(this).prop('disabled', true);
    $(this).addClass('checked');
    $("#CartDrawer").addClass('swapping');

    var idToRemove = $(this).data('key')
    var itemToAddToCart = $(this);
    var data = {
      quantity: itemToAddToCart.data('quantity'),
      id: itemToAddToCart.data('subscription_variant_id'),
    }

    if($(this).data('shipping_interval_frequency')!="" && $(this).data('shipping_interval_unit_type')!="") {
      data.properties = {};
      data.properties['shipping_interval_frequency'] = $(this).data('shipping_interval_frequency');
      data.properties['shipping_interval_unit_type'] = $(this).data('shipping_interval_unit_type');
    }

    /*$.post('/cart/change.js', { quantity: 0, id: idToRemove }).always(function() {
      $.post('/cart/add.js', data, function(cart){
        if($('body').hasClass('template-cart')) {
          window.location.reload();
        } else {
          ajaxCart.load();
          theme.RightDrawer.open();
        }        
      }, 'json');
    });*/
  } else {
    $(this).prop('disabled', true);
    $(this).removeClass('checked');
    $("#CartDrawer").addClass('swapping');

    var idToRemove = $(this).data('key')
    var itemToAddToCart = $(this);

    var data = {
      quantity: itemToAddToCart.data('quantity'),
      id: itemToAddToCart.data('original_variant_id'),
    }

    /*$.post('/cart/change.js', { quantity: 0, id: idToRemove }).always(function() {
      $.post('/cart/add.js', data, function(cart){
        ajaxCart.load();
        theme.RightDrawer.open();
      }, 'json');
    });*/
  }
});

if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');  
  $.ajax({
    type: 'GET',
    url: '/cart?view=json',
    success: function (response) {
      var cart = JSON.parse(response);
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $(document.body).trigger('afterGetCart.ajaxCart', cart);

      var data = JSON.stringify(cart);
      var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
      if (data.indexOf("subscription_id") > -1 || data.indexOf("Auto renew") > -1) {
        var paramDomain = 'myshopify_domain=premamawellness.myshopify.com';
        try {
          var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
        } catch (err) {
          var paramLinker = '';
        }
        var paramCustomer = '';
        var paramDiscount = '';
        $('body').find('button.cart__checkout').attr("href","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount+"&autoadddiscount=true");
        $('body').find('form.cart.ajaxcart').attr("action","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount+"&autoadddiscount=true");
        // $('body').find('button.cart__checkout').attr("href","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount+"&populatecode=true");
        // $('body').find('form.cart.ajaxcart').attr("action","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount+"&populatecode=true");
        //$('body').find('button.cart__checkout').attr("href","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount);
        //$('body').find('form.cart.ajaxcart').attr("action","https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + paramDiscount);
      } else {
        $('body').find('button.cart__checkout').attr("href","/checkout");
        $('body').find('form.cart.ajaxcart').attr("action","/checkout");
      }
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
    $("#CartDrawer").removeClass('swapping');
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      $formContainer.find('*[required]').parent().removeClass('error');
      $formContainer.find('.errors.fields-error').remove();

      //validate form
      var errors = false;
      $.each($formContainer.find('*[required]'), function(i,val) {
        if($(this).val() == "") {
          console.log("name="+$(this).attr('name'),$(this).val());
          errors = true;
          $(this).parent().addClass('error');
        }
      });

      if(errors){
        $addToCart.after('<div class="errors fields-error">Verifică iar detaliile felicitării. Lipsesc unele informații necesare.</div>')
      } else {
        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      }
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="cart-empty">' + "Your cart is currently empty." + '</p>');
      $('body').removeClass('cart-has-subscription');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        upsellItems = [],
        hasSubscription = false,
        subscriptionPrice = false,
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Upsell
    
      var has_upsell_trigger_in_cart = false;
      var upsell_trigger_handles = [];
      var upsell_targeted_handles = {};
      var valid_upsell_handles = [];
      var invalid_upsell_handles = []; 

      
        
        
        
          upsell_trigger_handles.push("birth-control-cleanse");

          
            
            upsell_targeted_handles["birth-control-cleanse"] = [];upsell_targeted_handles["birth-control-cleanse"].push("fertility-support-for-her");upsell_targeted_handles["birth-control-cleanse"].push("prenatal-vitamin");
        
      
        
        
        
          upsell_trigger_handles.push("new-birth-control-cleanse");

          
            
            upsell_targeted_handles["new-birth-control-cleanse"] = [];upsell_targeted_handles["new-birth-control-cleanse"].push("fertility-support-for-her");upsell_targeted_handles["new-birth-control-cleanse"].push("prenatal-vitamin");
        
      
        
        
        
          upsell_trigger_handles.push("fertility-support-for-her");

          
            
            upsell_targeted_handles["fertility-support-for-her"] = [];upsell_targeted_handles["fertility-support-for-her"].push("prenatal-vitamin");upsell_targeted_handles["fertility-support-for-her"].push("birth-control-cleanse");
        
      
        
        
        
          upsell_trigger_handles.push("new-fertility-support-for-her");

          
            
            upsell_targeted_handles["new-fertility-support-for-her"] = [];upsell_targeted_handles["new-fertility-support-for-her"].push("prenatal-vitamin");upsell_targeted_handles["new-fertility-support-for-her"].push("birth-control-cleanse");
        
      
        
        
        
          upsell_trigger_handles.push("fertility-support-for-him");

          
            
            upsell_targeted_handles["fertility-support-for-him"] = [];upsell_targeted_handles["fertility-support-for-him"].push("dual-fertility-bundle");
        
      
        
        
        
          upsell_trigger_handles.push("prenatal-vitamin");

          
            
            upsell_targeted_handles["prenatal-vitamin"] = [];upsell_targeted_handles["prenatal-vitamin"].push("energy-boost-drink-mix");
        
      
        
        
        
          upsell_trigger_handles.push("new-prenatal-vitamin");

          
            
            upsell_targeted_handles["new-prenatal-vitamin"] = [];upsell_targeted_handles["new-prenatal-vitamin"].push("energy-boost-drink-mix");
        
      
        
        
        
          upsell_trigger_handles.push("energy-boost-drink-mix");

          
            
            upsell_targeted_handles["energy-boost-drink-mix"] = [];upsell_targeted_handles["energy-boost-drink-mix"].push("prenatal-vitamin");
        
      
        
        
        
          upsell_trigger_handles.push("digestive-relief-chews");

          
            
            upsell_targeted_handles["digestive-relief-chews"] = [];upsell_targeted_handles["digestive-relief-chews"].push("energy-boost-drink-mix");upsell_targeted_handles["digestive-relief-chews"].push("prenatal-vitamin");
        
      
        
        
        
          upsell_trigger_handles.push("postnatal-vitamins");

          
            
            upsell_targeted_handles["postnatal-vitamins"] = [];upsell_targeted_handles["postnatal-vitamins"].push("lactation-support-drink-mix");
        
      
        
        
        
          upsell_trigger_handles.push("lactation-support-drink-mix");

          
            
            upsell_targeted_handles["lactation-support-drink-mix"] = [];upsell_targeted_handles["lactation-support-drink-mix"].push("postnatal-vitamins");
        
      

      $.each(cart.items, function(index, cartItem) {
        if(cartItem.properties) {
          if(cartItem.properties._upsell !== undefined) {
            return;
          }
        }

        if(upsell_trigger_handles.includes(cartItem.handle) || upsell_trigger_handles.includes(cartItem.handle.replace("-1",""))) {
          if(!has_upsell_trigger_in_cart) has_upsell_trigger_in_cart = cartItem.handle.replace("-1","");
        }
      });

      if(has_upsell_trigger_in_cart) {
        $.each(cart.items, function(index, cartItem) {
          if(upsell_targeted_handles[has_upsell_trigger_in_cart].includes(cartItem.handle)) {
            invalid_upsell_handles.push(cartItem.handle)
          } else {
            return;
          }
        });

        if(invalid_upsell_handles.length < upsell_targeted_handles[has_upsell_trigger_in_cart].length) {
          $.each(upsell_targeted_handles[has_upsell_trigger_in_cart], function(index, upsellHandle) {
            if(invalid_upsell_handles.includes(upsellHandle)) {
              return;
            } else {
              valid_upsell_handles.push(upsellHandle);
            }
          });
        }

        if(valid_upsell_handles.length) {
          $.each(valid_upsell_handles, function(index, validUpsell) {
            upsellItems.push(
              {
                id: window.upsell_targeted_product_data[validUpsell].id,
                variantId: window.upsell_targeted_product_data[validUpsell].variant_id,
                price: window.upsell_targeted_product_data[validUpsell].price,
                title: window.upsell_targeted_product_data[validUpsell].title,
                image: window.upsell_targeted_product_data[validUpsell].image,
                upsellTrigger: has_upsell_trigger_in_cart
              }
            )
          })
        }
      }
    

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image2 != null){
        var prodImg = cartItem.image2.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      var hideQty = false;
      var subscriptionCheckbox = false;
      var cartItemProperties = {};      
      var cartItemUrl = cartItem.url;
      var freeTrial = false;
      var original_product_id = false;
      var isSubscription = false;

      if(available_products[cartItem.id]) {
        if(available_products[cartItem.id].is_subscription_product == false && available_products[cartItem.id].has_subscription) {
          subscriptionCheckbox = `<div class="subscription-swap">
            <input type="checkbox" name="swap-product" data-key="`+cartItem.key+`" data-quantity="`+cartItem.quantity+`" data-original_variant_id="`+cartItem.id+`" data-subscription_variant_id="`+available_products[cartItem.id].subscription_variant_id+`" data-shipping_interval_frequency="`+available_products[cartItem.id].shipping_interval_frequency+`" data-shipping_interval_unit_type="`+available_products[cartItem.id].shipping_interval_unit_type+`" value="1">`;
          if (available_products[cartItem.id].discount_percentage == 0) {
            subscriptionCheckbox += `<label>Subscribe + Free Shipping </label>`;
          } else {
            subscriptionCheckbox += `<label>Subscribe & Save `+available_products[cartItem.id].discount_percentage+`% + Free Shipping </label>`;
          } 
          subscriptionCheckbox += `</div>`;
        }
        if(available_products[cartItem.id].is_subscription_product == true) {
          isSubscription = true;
          if(!hasSubscription) {
            hasSubscription = true;            
          }
          original_product_id = available_products[cartItem.id].original_product_id;
          cartItemUrl = "/products/"+available_products[cartItem.id].original_handle;
          subscriptionCheckbox = `<div class="subscription-swap">
            <input type="checkbox" class="checked" name="swap-product" data-key="`+cartItem.key+`" data-quantity="`+cartItem.quantity+`" data-original_variant_id="`+available_products[cartItem.id].original_variant_id+`" data-subscription_variant_id="`+available_products[cartItem.id].subscription_variant_id+`" data-shipping_interval_frequency="`+available_products[cartItem.id].shipping_interval_frequency+`" data-shipping_interval_unit_type="`+available_products[cartItem.id].shipping_interval_unit_type+`" value="1">`;
          if (available_products[cartItem.id].discount_percentage == 0) {
            subscriptionCheckbox += `<label>Subscribe + Free Shipping </label>`;
          } else {
            subscriptionCheckbox += `<label>Subscribe & Save `+available_products[cartItem.id].discount_percentage+`% + Free Shipping </label>`;
          } 
          subscriptionCheckbox += `</div>`;

          if(original_product_id == 497330618414) { //balance
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 3961211781166) { //postnatal
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 497339498542) { //fertility support him    
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 497333764142) { //fertility support her    
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 497342021678) { //prenatal   
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 497348313134) { //energy
            subscriptionPrice = cartItem.line_price;
          }
          if(original_product_id == 497346674734) { //lactation
            subscriptionPrice = cartItem.line_price;
          }
        }
      }

      // Create item's data object and add to 'items' array
      item = {
        subscriptionCheckbox: subscriptionCheckbox,
        isSubscription: isSubscription,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItemUrl,
        img: prodImg,
        name: cartItem.product_title.replace('20.00% Off Auto renew','Subscription').replace('100.00% Off Auto renew','Subscription'),
        properties: cartItemProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        hideQty: hideQty,
        freeTrial: freeTrial,
        original_product_id: original_product_id,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    if(hasSubscription) {
      $('body').addClass('cart-has-subscription');
    } else {
      $('body').removeClass('cart-has-subscription');
    }
    data = {
      items: items,
      hasUpsell: upsellItems.length == 0 ? false : true,
      upsellItems: upsellItems,
      note: cart.note,
      totalPrice: hasSubscription ? Shopify.formatMoney(cart.total_price, settings.moneyFormat)  : Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You are saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    /*if($("body").hasClass('cart-has-subscription')) {
       if($('.ajaxcart__product-price[data-original-product-id="497346674734"]').length) { //lactation
        $('.ajaxcart__product-price[data-original-product-id="497346674734"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497346674734"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497346674734"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="497348313134"]').length) { //energy
        $('.ajaxcart__product-price[data-original-product-id="497348313134"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497348313134"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497348313134"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="497342021678"]').length) { //prenatal    
        $('.ajaxcart__product-price[data-original-product-id="497342021678"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497342021678"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497342021678"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="497333764142"]').length) { //fertility support her    
        $('.ajaxcart__product-price[data-original-product-id="497333764142"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497333764142"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497333764142"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="497339498542"]').length) { //fertility support him
        $('.ajaxcart__product-price[data-original-product-id="497339498542"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497339498542"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497339498542"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="3961211781166"]').length) { //postnatal
        $('.ajaxcart__product-price[data-original-product-id="3961211781166"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="3961211781166"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="3961211781166"]').append(" each subsequent shipment");
      } else if($('.ajaxcart__product-price[data-original-product-id="497330618414"]').length) { //balance
        $('.ajaxcart__product-price[data-original-product-id="497330618414"]').addClass('has-free-trial');
        $('.ajaxcart__product-price[data-original-product-id="497330618414"]').prepend("<span>1ST Shipment FREE</span><br/>");
        $('.ajaxcart__product-price[data-original-product-id="497330618414"]').append(" each subsequent shipment");
      }
    } */

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('click', '.ajaxcart__product-remove', function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line');

      updateQuantity(line, 0);
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');
    console.log("qty Selectors init")

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('body').on('click', '.js-qty__adjust', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);

        if($('body').hasClass('template-cart')) $(this).closest('form').submit();
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));